// Illinois Tech's undergraduate majors (#2840). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog (catalog.iit.edu/undergraduate/
// colleges/), each college page's list of bachelor's programs (department
// pages checked for programs the college page leaves out; none found).
// Every "Bachelor of ..." line kept, written as the major plus the degree
// the catalog names; dual degrees keep both degrees. Left out: minors,
// certificates, graduate programs, the School of Design and Society (its
// catalog page lists no bachelor's degree, only a minor), Interdisciplinary
// Education (certificates only) and Illinois Tech Global (its one program,
// the Bachelor of Information Technology, is listed under the School of
// Computing). Biochemistry appears under both Biology and Chemistry in the
// Lewis school and is kept once. Programs the catalog marks with an asterisk
// ("Indicates that this program is an Incubator Program") carry that note.
// Group names are the catalog's, with its zero-width spaces removed. The
// KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "illinois-institute-of-technology",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Illinois Tech's official 2026-2027 Undergraduate Catalog, grouped by the college and school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Tech Futures College - Armour School of Engineering, Applied Science, and Health",
            "source": {
                "label": "Illinois Tech 2026-2027 Undergraduate Catalog, Tech Futures College - Armour School of Engineering, Applied Science, and Health",
                "url": "https://catalog.iit.edu/undergraduate/colleges/engineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Engineering Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer and Cybersecurity Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering and Computer Engineering (dual degree)",
                    "degree": "Bachelor of Science/Bachelor of Science"
                },
                {
                    "name": "Industrial Technology and Management",
                    "degree": "Bachelor of Industrial Technology and Management"
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Tech Futures College - Armour School of Engineering, Applied Science, and Health (Formerly Lewis)",
            "source": {
                "label": "Illinois Tech 2026-2027 Undergraduate Catalog, Tech Futures College - Armour School of Engineering, Applied Science, and Health (Formerly Lewis)",
                "url": "https://catalog.iit.edu/undergraduate/colleges/science-letters/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry with Artificial Intelligence",
                    "degree": "Bachelor of Science",
                    "note": "An Incubator Program in the catalog."
                },
                {
                    "name": "Biochemistry and Psychological Science (dual degree)",
                    "degree": "Bachelor of Science/Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology and Psychological Science (dual degree)",
                    "degree": "Bachelor of Science/Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Game Design and Experiential Media",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Game Design and Experiential Media with Artificial Intelligence",
                    "degree": "Bachelor of Science",
                    "note": "An Incubator Program in the catalog."
                },
                {
                    "name": "Game Production Management (with Stuart School of Business)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Humanities",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Astrophysics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Astrophysics with Artificial Intelligence",
                    "degree": "Bachelor of Science",
                    "note": "An Incubator Program in the catalog."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics with Artificial Intelligence",
                    "degree": "Bachelor of Science",
                    "note": "An Incubator Program in the catalog."
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Information Systems and Psychology (dual degree)",
                    "degree": "Bachelor of Science/Bachelor of Science"
                },
                {
                    "name": "Public Policy",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Tech Futures College - School of Computing",
            "source": {
                "label": "Illinois Tech 2026-2027 Undergraduate Catalog, Tech Futures College - School of Computing",
                "url": "https://catalog.iit.edu/undergraduate/colleges/computing/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Statistics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Science (with Applied Mathematics)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Information Technology",
                    "degree": "Bachelor of Information Technology"
                },
                {
                    "name": "Information Technology and Management",
                    "degree": "Bachelor of Information Technology and Management"
                },
                {
                    "name": "Applied Cybersecurity and Information Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity with Artificial Intelligence",
                    "degree": "Bachelor of Science",
                    "note": "An Incubator Program in the catalog."
                }
            ]
        },
        {
            "name": "Design Futures College - School of Architecture",
            "source": {
                "label": "Illinois Tech 2026-2027 Undergraduate Catalog, Design Futures College - School of Architecture",
                "url": "https://catalog.iit.edu/undergraduate/colleges/architecture/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Architecture"
                },
                {
                    "name": "Architectural Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Architectural Studies with Artificial Intelligence",
                    "degree": "Bachelor of Arts",
                    "note": "An Incubator Program in the catalog."
                },
                {
                    "name": "Construction Management and Architectural Technology",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Professional Futures College - Stuart School of Business",
            "source": {
                "label": "Illinois Tech 2026-2027 Undergraduate Catalog, Professional Futures College - Stuart School of Business",
                "url": "https://catalog.iit.edu/undergraduate/colleges/business/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration with Artificial Intelligence",
                    "degree": "Bachelor of Science",
                    "note": "An Incubator Program in the catalog."
                },
                {
                    "name": "Business Analytics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business and Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business and Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business and Information Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business and Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Financial Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Game Production Management (with Humanities)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Marketing Analytics",
                    "degree": "Bachelor of Science"
                }
            ]
        }
    ]
};

export default majors;
